import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { ToastrService } from 'ngx-toastr';
import { sweetAlert } from "../../../utils/swal";
import {
  downloadFile,
  downloadFileAsBlob,
  getArrayBuffer,
} from "src/app/utils/pdf-downloader";
import * as moment from "moment-timezone";
import { ActivatedRoute, Router } from "@angular/router";
import { urls } from "src/app/utils/url-utils";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import * as _ from "underscore";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { DispatchCenterService } from "../../dashboard/dashboard-service/dispatch-center-service";
import { FleetService } from "../../fleet/fleet-service/fleet.service";
import {
  PAYOR,
  checkRole,
  exportToCsv,
  getBillingBrokers,
  getBrokersList,
  urlToBase64,
} from "src/app/utils/utils.common";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { generatePdf, getCompanyLogo, getRandomString } from "src/app/utils/utils.common";
import { PDFDocument } from "pdf-lib";
import { isArray } from "util";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FilterPipe } from "src/app/pipe/list-filter-pipe/list-filter-pipe";
import { FilterByKeyPipe } from "src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe";
import { ModivcareReportService } from "src/app/service/modivcare-report-service/modivcare-report.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { UserRoles } from "../../shared/layout/menu-service/menu.service";
import { CsvService } from "src/app/service/csv-service/csv.service";
import { ReportService } from "../../reports/reports-service/report.service";
import { Cms1500Service } from "src/app/service/cms-service/cms1500.service";
import { CatServiceService } from "src/app/service/cat-service/cat-service.service";
import { DriverLogService } from "src/app/service/driver-log-service/driver-log.service";
import { MemberLogService } from "src/app/service/member-log-service/member-log.service";
import { environment } from "src/environments/environment";
import { CorporateReportService } from "src/app/service/corporate-report-service/corporate-report.service";
import { cancelledTripsReport } from "../../reports/pdf-reports/cancelled-trips";
import { VeridaTrfService, TrfHeader, TripLeg } from "src/app/service/verida-trf-service/verida-trf.service";
@Component({
  selector: "app-verified-trip-logs",
  templateUrl: "./verified-trip-logs.component.html",
  styleUrls: ["./verified-trip-logs.component.css"],
})
export class VerifiedTripLogsComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;

  minDate;
  maxDate;
  // tslint:disable-next-line: ban-types
  public signaturePadOptions: Object = {
    // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 750,
    canvasHeight: 300,
  };


  status;
  user;
  timeZone;
  searchDate;
  dateRange;
  search = "";
  dataList = [];
  filteredAdjustedTrips = [];
  selectedTrips = [];
  selectedTripJobIds = [];
  brokers;
  // selectedBroker = "";

  drivers = [];
  members = [];
  selectedDriver = "";
  selectedMember = "";
  corporateUsers;
  selectedCorporateUser;
  isMedical = false;

  projectedOdometer = "";
  tempVin;
  odometerBegin;
  odometerStart;
  odometerStop;

  isOdometerRequest = false;
  isAllTripsSelected = false;

  popupAssignTrip: any;
  bankedType;
  debounceTimers: { [key: string]: any } = {};

  jobType = "assigned";
  type = null;
  tempCompanyImage =
    "https://s3.amazonaws.com/neighborhood-dev/assets/brokers/MixandMatch.png";
  companyImage = this.tempCompanyImage;
  fleet;
  isShowFilter = false;
  odomterModalObj;
  signatureModalObj;

  preCorporate;
  preFleet;
  preLevelOfServices = {};
  preSpaceTypes = {};
  columnSearches: any = {
    driver: '',
    fundingSource: '',
    spaceType: '',
    tripId: '',
    authorizationNumber: '',
    mrn: '',
    puDate: '',
    doDate: '',
    puTime: '',
    doTime: '',
    patient: '',
    phone: '',
    pickupAddress: '',
    dropoffAddress: '',
    milage: '',
    escort: '',
    specialRate: '',
  };
  sortColumn = '';
  sortDirection: 'asc' | 'desc' | '' = '';

  driverLoader = {
    isLoading: false,
  };

  modivcareTripLog = {
    isLoading: false
  }
  isTripLogLoader = {
    isLoading: false
  }
  isColoradoReport = {
    loader: false
  }

  trfLoader = {
    isLoading: false
  }
  coReportLoader = {
    isLoading: false
  };

  memberLoader = {
    isLoading: false,
  };
  paramountLoader = {
    isModal: false,
    isLoading: false
  };
  selectedCorporateId = '';
  view = "grid";
  alertMessage = "";
  orderBy = "scheduleTime";
  selectedDropdownIndex
  toggleActionButtons = false;
  isAllowRates: boolean = false;
  isAHCCCSFile = false;
  isProduction = environment.production;
  todayDate;
  corporateLoader = {
    isLoading: false,
  };
  simpleCorporateInvoiceLoader = {
    isLoading: false,
  };
  isMemberTripsLogDownloading = false;
  isTripsLogHMTLoading = false;
  isMemberMBRloading = false;
  isMemberFile = false;
  timeFormat: string = 'HHmm';
  isBulkAdjustmentLoading = false;
  isCancelledTripsLoading = false;
  isVeridaTrfLoading = false;


  constructor(
    private csvService: CsvService,
    private levelOfServiceService: LevelOfServiceService,
    private modivcareService: ModivcareReportService,
    private reportService: ReportService,
    private assignTripService: AssigTripsService,
    private fleetService: FleetService,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService,
    private cms1500Service: Cms1500Service,
    private router: Router,
    private catService : CatServiceService,
    private driverLogService : DriverLogService,
    private memberLogService: MemberLogService,
    private corporateReportService: CorporateReportService,
    private dispatchCenterService: DispatchCenterService,
    private toastr: ToastrService,
    private veridaTrfService: VeridaTrfService
  ) { }

  ngOnInit() {
    this.status = "adjustedtriplogs";
    this.brokers = getBillingBrokers;
    this.getUser();
    this.getCorporateUsers();
    this.getFleetList();
    this.getSpaceTypes();
    this.getLevelOfService();
  }

  ngAfterViewInit() {
    if (this.signaturePad) {
      // this.signaturePad is now available
      this.signaturePad.set("minWidth", 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.timeZone = user.timeZone;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.user = user;
          if (user.timeFormat) {
            this.timeFormat = user.timeFormat;
          }
          // this.searchDate = moment().startOf('day').toISOString();
          this.searchDate = moment
            .tz(this.timeZone)
            .startOf("day")
            .toISOString();
          this.dateRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];

          this.minDate = moment.tz(this.timeZone).startOf("day").toISOString();
          this.maxDate = moment.tz(this.timeZone).add(1, 'month').startOf("day").toISOString();

          this.isAllowRates = checkRole(this.user);
          if (this.user.hasOwnProperty('isListView') && this.user.isListView) {
            this.setView('list');
          }
          this.getAdjustedTrips();
        }


      });
  }

  setView(type) {
    this.view = type;
  }

  getCorporateUsers() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data;

          this.preCorporate = data.reduce(
            (obj, item) => ((obj[item._id] = item), obj),
            {}
          );

        }
      });
  }

  getCorporateByID(id) {
    return this.preCorporate[id];
  }

  getAdjustedTrips() {
    let queryParams = {
      status: this.status,
      // scheduleTime: this.searchDate,
      scheduleTime:  this.dateRange.toString(),
      jobType: this.jobType,
    };

    if (this.isMedical) {
      queryParams["isMedical"] = this.isMedical;
    }

    if (this.selectedCorporateId) {
      queryParams["cooperate"] = this.selectedCorporateId;
    }


    this.members = [];
    this.drivers = [];
    this.selectedTrips = [];
    this.filteredAdjustedTrips = [];
    this.dataList = [];

    this.search = "";
    this.selectedMember = "";
    this.selectedDriver = "";
    this.sortColumn = '';
    this.sortDirection = '';
    Object.keys(this.columnSearches).forEach((key) => {
      this.columnSearches[key] = '';
    });

    this.assignTripService
      .getAdjustedTripsList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList = data;
          this.filteredAdjustedTrips = data;

          this.dataList.forEach((trip, i) => {
            const isFound = this.drivers.some(
              (driver) => driver._id === trip.driver._id
            );
            if (!isFound) {
              this.drivers.push(trip.driver);
            }
            this.members.push(trip.priorityClient);
          });

          this.members = _.uniq(this.members, (obj) => obj.displayName);
          this.group()
          this.filterTripsByModel();
        }
      });
  }

  onSearchDateChange(event) {
    this.searchDate = event.toISOString();
    this.getAdjustedTrips();
  }


  onDateRangeChange(event) {
    const duration = moment.duration(event[1].diff(event[0]));
    const diffInDays = duration.asMonths();
    if (diffInDays < 1) {
      this.dateRange = [
        event[0].toISOString(),
        event[1].endOf("day").toISOString(),
      ];
      this.getAdjustedTrips();
      return;
    }

    this.dateRange = [];
    sweetAlert("Error", 'You can only select a date range of up to 30 days.', "warning", "Ok");

  }

  onSelectCorporateUser() {
    if (this.selectedCorporateId) {
      this.selectedCorporateUser = this.preCorporate[this.selectedCorporateId];
      this.jobType = "cooperate";
      this.isMedical = false;

      this.getAdjustedTrips();
    } else {
      this.selectedCorporateId = "";
      this.selectedCorporateUser = null;
      this.jobType = "assigned";
      this.companyImage = this.tempCompanyImage;
      this.getAdjustedTrips();
    }

  }

  onSelectDriver() {
    this.filterTripsByModel();
    if (this.filteredAdjustedTrips.length) {
      const trip = this.filteredAdjustedTrips[0];
      if (trip && trip.fleet) {
        const fleetId = trip.fleet;
        this.projectedOdometer = null;
        this.fleetService
          .getFleetDataById(fleetId)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              this.fleet = data;
              // this.projectedOdometer = this.fleet[this.selectedBroker];
            }
          });
      }
    }
  }

  // Trip Selection Starts
  selectTrips(assign) {
    const index = this.selectedTrips.indexOf(assign._id);
    if (index > -1) {
      assign.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      assign.isSelected = true;
      this.selectedTrips.push(assign._id);
    }
  }

  selectAll() {

    this.filteredAdjustedTrips.forEach((assign) => {
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filteredAdjustedTrips.length;
    return this.isAllTripsSelected;
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filteredAdjustedTrips.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });
    this.selectedTrips = this.selectedTrips.filter(
      (x) => !unselectedTrips.includes(x)
    );
    this.isAllTripsSelected = false;
  }

  filterTripsByModel() {
    this.filteredAdjustedTrips = this.dataList;

    this.filteredAdjustedTrips = new FilterPipe().transform(
      this.filteredAdjustedTrips,
      this.search
    );

    this.filterByColumnSearches();

    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.priorityClient.displayName",
      this.selectedMember
    );


    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.driver._id",
      this.selectedDriver
    );

    this.applyColumnSort();
  }

  hasActiveColumnSearches(): boolean {
    return Object.keys(this.columnSearches).some(
      (key) => !!(this.columnSearches[key] && String(this.columnSearches[key]).trim())
    );
  }

  clearColumnSearches() {
    Object.keys(this.columnSearches).forEach((key) => {
      this.columnSearches[key] = '';
    });
    this.search = '';
    this.sortColumn = '';
    this.sortDirection = '';
    this.filterTripsByModel();
  }

  sortByColumn(column: string) {
    if (this.sortColumn === column) {
      if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortColumn = '';
        this.sortDirection = '';
        this.filterTripsByModel();
        return;
      } else {
        this.sortDirection = 'asc';
      }
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.applyColumnSort();
  }

  applyColumnSort() {
    if (!this.sortColumn || !this.sortDirection || !this.filteredAdjustedTrips || !this.filteredAdjustedTrips.length) {
      return;
    }
    const column = this.sortColumn;
    const direction = this.sortDirection;
    this.filteredAdjustedTrips.sort((a: any, b: any) => {
      let valA = this.getSortValue(a, column);
      let valB = this.getSortValue(b, column);

      if (valA === null || valA === undefined || valA === '') valA = '';
      if (valB === null || valB === undefined || valB === '') valB = '';

      if (typeof valA === 'number' && typeof valB === 'number') {
        if (valA < valB) return direction === 'asc' ? -1 : 1;
        if (valA > valB) return direction === 'asc' ? 1 : -1;
        return 0;
      }

      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();
      if (strA < strB) return direction === 'asc' ? -1 : 1;
      if (strA > strB) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }

  private getSortValue(trip: any, key: string): any {
    switch (key) {
      case 'status':
        return trip.status || '';
      case 'driver':
        return (trip.driver && trip.driver.displayName) || '';
      case 'fundingSource':
        return (this.preCorporate && this.preCorporate[trip.cooperate] && this.preCorporate[trip.cooperate].displayName) || '';
      case 'spaceType': {
        const los = (this.preLevelOfServices && this.preLevelOfServices[trip.fleet] && this.preLevelOfServices[trip.fleet].title) || '';
        const space = (this.preSpaceTypes && this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title) || '';
        return `${los} ${space}`.trim();
      }
      case 'tripId':
        return trip.tripId || trip.refTripId || '';
      case 'authorizationNumber':
        return trip.authorizationNumber || '';
      case 'mrn':
        return (trip.priorityClient && trip.priorityClient.clientId) || '';
      case 'puDate':
      case 'puTime':
        return trip.scheduleTime ? moment(trip.scheduleTime).valueOf() : 0;
      case 'doDate':
      case 'doTime':
        return trip.appointmentTime ? moment(trip.appointmentTime).valueOf() : 0;
      case 'patient':
        return (trip.priorityClient && trip.priorityClient.displayName) || '';
      case 'phone':
        return (trip.priorityClient && trip.priorityClient.contactNumber) || '';
      case 'pickupAddress':
        return trip.jobOriginAddress || '';
      case 'dropoffAddress':
        return trip.jobDestinationAddress || '';
      case 'milage':
        return trip.milage != null && trip.milage !== '' ? Number(trip.milage) : 0;
      case 'escort':
        return trip.noOfEscorts != null && trip.noOfEscorts !== '' ? Number(trip.noOfEscorts) : 0;
      case 'specialRate':
        return trip.preSpecialRate != null && trip.preSpecialRate !== '' ? Number(trip.preSpecialRate) : 0;
      default:
        return this.getColumnSearchValue(trip, key);
    }
  }

  private matchesColumnSearch(value: any, term: string): boolean {
    if (!term || !String(term).trim()) {
      return true;
    }
    if (value === null || value === undefined) {
      return false;
    }
    return String(value).toLowerCase().includes(String(term).trim().toLowerCase());
  }

  private getColumnSearchValue(trip: any, key: string): string {
    switch (key) {
      case 'driver':
        return (trip.driver && trip.driver.displayName) || '';
      case 'fundingSource':
        return (this.preCorporate && this.preCorporate[trip.cooperate] && this.preCorporate[trip.cooperate].displayName) || '';
      case 'spaceType': {
        const los = (this.preLevelOfServices && this.preLevelOfServices[trip.fleet] && this.preLevelOfServices[trip.fleet].title) || '';
        const space = (this.preSpaceTypes && this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title) || '';
        return `${los} ${space}`.trim();
      }
      case 'tripId':
        return [trip.refTripId, trip.tripId].filter(Boolean).join(' ');
      case 'authorizationNumber':
        return trip.authorizationNumber || '';
      case 'mrn':
        return (trip.priorityClient && trip.priorityClient.clientId) || '';
      case 'puDate':
        return trip.scheduleTime
          ? (this.timeZone
              ? moment(trip.scheduleTime).tz(this.timeZone).format('MM/DD/YYYY')
              : moment(trip.scheduleTime).format('MM/DD/YYYY'))
          : '';
      case 'doDate':
        return trip.appointmentTime
          ? (this.timeZone
              ? moment(trip.appointmentTime).tz(this.timeZone).format('MM/DD/YYYY')
              : moment(trip.appointmentTime).format('MM/DD/YYYY'))
          : '';
      case 'puTime':
        return trip.scheduleTime
          ? (this.timeZone
              ? moment(trip.scheduleTime).tz(this.timeZone).format('HH:mm')
              : moment(trip.scheduleTime).format('HH:mm'))
          : '';
      case 'doTime':
        return trip.appointmentTime
          ? (this.timeZone
              ? moment(trip.appointmentTime).tz(this.timeZone).format('HH:mm')
              : moment(trip.appointmentTime).format('HH:mm'))
          : '';
      case 'patient':
        return (trip.priorityClient && trip.priorityClient.displayName) || '';
      case 'phone':
        return [
          trip.priorityClient && trip.priorityClient.contactNumber,
          trip.priorityClient && trip.priorityClient.cellPhone,
        ]
          .filter(Boolean)
          .join(' ');
      case 'pickupAddress':
        return trip.jobOriginAddress || '';
      case 'dropoffAddress':
        return trip.jobDestinationAddress || '';
      case 'milage':
        return trip.milage != null ? String(trip.milage) : '';
      case 'escort':
        return trip.noOfEscorts != null ? String(trip.noOfEscorts) : '';
      case 'specialRate':
        return trip.preSpecialRate != null ? String(trip.preSpecialRate) : '';
      default:
        return '';
    }
  }

  filterByColumnSearches() {
    if (!this.hasActiveColumnSearches()) {
      return;
    }
    this.filteredAdjustedTrips = this.filteredAdjustedTrips.filter((trip) => {
      return Object.keys(this.columnSearches).every((key) => {
        const term = this.columnSearches[key];
        if (!term || !String(term).trim()) {
          return true;
        }
        return this.matchesColumnSearch(this.getColumnSearchValue(trip, key), term);
      });
    });
  }

  getSelectedTrips() {
    return this.dataList.filter((trip) => trip.isSelected);
  }

  adjustOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };
    this.assignTripService
      .adjustTripOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
          this.getAdjustedTrips();
        }
      });
  }

  // OK
  nextOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };

    this.assignTripService
      .adjustAllTripsOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
          this.getAdjustedTrips();
        }
      });
  }

  signatureUpdate(isSignature) {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      isSignature: isSignature,
    };

    this.assignTripService
      .signatureUpdate(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Updated Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // OK
  bankedTrips() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: "banked",
    };

    this.assignTripService
      .bankedTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Banked the Trip Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // Adjust Odometer
  showOdometerModal(trip) {
    this.odomterModalObj = trip;
  }

  onSaveOdometer(evt) {
    this.dataList.forEach((item, i) => {
      if (item._id === evt._id) {
        this.dataList[i].odometerBegin = evt.odometerBegin;
        this.dataList[i].odometerStart = evt.odometerStart;
        this.dataList[i].odometerStop = evt.odometerStop;
      }
    });
    this.odomterModalObj = null;
  }

  // Signature
  showSignatureModal(trip) {
    this.signatureModalObj = trip;
  }

  onSaveSignature(data) {
    if (data) {
      this.signatureModalObj.signatureImage = data + "?" + Math.random();
      // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
      const payload = {
        isEmpty: false,
        dataUrl: data,
      };
      this.assignTripService
        .generateSignature(payload, this.signatureModalObj._id)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            const filteredSignature = this.filteredAdjustedTrips.find((item) => item._id === this.signatureModalObj._id)
            filteredSignature.signatureImage = data.signatureImage;
            this.signatureModalObj.signatureImage = data.signatureImage;
            this.signatureModalObj = null;
          }
        });
    }
  }

  getBroker(key) {
    return getBrokersList[key];
  }

  // Banked
  bankedSingleTrip(assign, status) {
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
    this.bankedType = status;
    // tslint:disable-next-line: max-line-length
    this.alertMessage =
      assign.bankStatus === "banked"
        ? "Are you sure you want to appeald against this trip ?"
        : "Are you sure you want to bank this trip ?";
    const object = {
      type: "adjustedtriplogs",
      _ids: [this.popupAssignTrip._id],
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: this.bankedType,
      statusType: "single",
    };
    this.assignTripService
      .bankedTrips(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `Trip ${this.bankedType === 'banked' ? 'Banked': 'Appealed'} Successfully`, 'success', 'OK');
          this.selectedTrips = [];
          this.selectedTripJobIds = [];
          this.getCorporateUsers();
          this.getAdjustedTrips();
        }
      });
  }

  bankedMultipalTrips() {
    this.alertMessage = "Are you sure you want to bank these trips ?";
  }
  // Signature

  updateTripSignature(assign) {
    this.signaturePad.clear();
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
  }

  generateSignature() {
    const object = {
      isEmpty: false,
      dataUrl: this.signaturePad.toDataURL(),
    };
    this.processSignature(object, this.popupAssignTrip._id);
  }

  processSignature(obj, id) {
    this.assignTripService
      .generateSignature(obj, id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
          const splitArray = data.signatureImage.split("/");
          const splitArrayTwo = splitArray[6].split(".");
          this.dataList.filter((item2) => {
            if (item2._id === splitArrayTwo[0]) {
              item2.signatureImage = data.signatureImage;
            }
          });
        }
      });
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  btnNagtiveResponse() {
    this.popupAssignTrip = JSON.parse(JSON.stringify({}));
    this.alertMessage = "";
  }
  // Methods will stay

  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }

  navigateToAdjustment(id) {
    const queryParams = { isFromBilling: true };
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/trips/${id}/adjust`], { queryParams })
    );
    window.open(url, "_blank");
    // this.router.navigate([`/trips/${id}/adjust`], { queryParams } );
  }

  async modivcareReport() {
    this.modivcareTripLog.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getModivcareReport(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.modivcareTripLog);
    }
  }

  async downloadTripLog() {
    this.isTripLogLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getTripLog(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.isTripLogLoader, this.selectedCorporateUser);
    }
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          // this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {


    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          // this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  downloadForm837Reportv2() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReportv2(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  openParamountModal(){
    this.paramountLoader.isModal = true;
  }

  downloadForm837Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReport(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  group(isNotFromButton?) {
    if (this.filteredAdjustedTrips && this.filteredAdjustedTrips.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filteredAdjustedTrips.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filteredAdjustedTrips.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  callthecarInvoice() {
    if (this.selectedTrips.length) {
      const selectedTripsObj = this.dataList.filter(trip => this.selectedTrips.includes(trip._id));
      this.csvService.downloadCTCInvoice(this.dateRange[0], selectedTripsObj, this.preFleet, this.user, this.timeZone);
    } else {
      return;
    }
  }

  cms1500Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload
    }
    this.assignTripService.getCMS1500Report(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  invoiceCSV() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload
    }
    this.assignTripService.getInvoiceCSV(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  mileageInvoiceCSV() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getMileageInvoiceCSV(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  // Member Log sheet v2
  mileageInvoiceCSV2() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getInvoiceCSV2(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }


  async downloadCoTripReport() {
    this.coReportLoader.isLoading = true;
    let trips;
    let groupedTrips = {}
    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    for (let trip of trips) {
      groupedTrips[trip.tripId] = {
        ...trip,
      };
    }
    await this.reportService.getCoTripReport(groupedTrips, this.user, this.searchDate, this.coReportLoader, this.preFleet);
  }

  async downloadCoTripLog() {
    this.isColoradoReport.loader = true;
    let trips;
    let groupedTrips = {}
    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    // for (let trip of trips) {
    //   groupedTrips[trip.tripId] = {
    //     ...trip,
    //   };
    // }
    await this.reportService.getColoradoTripLog(trips, this.user, this.searchDate, this.isColoradoReport, this.preFleet, this.preLevelOfServices, this.preSpaceTypes);
  }


  calculateFare(miles, prevMiles, prevTotal) {
    let total = 0;
    if (!prevMiles) {
      if (miles <= 20) {
        total = 50;
      }

      if (miles > 20) {
        let extraMiles = miles - 20;
        total += 50 + extraMiles * 1.5;
      }
    } else {
      if (miles <= 20) {
        total = 50;
      }

      if (miles > 20) {
        let extraMiles = miles - 20;
        total += 50 + extraMiles * 1.5;
      }
    }

    return prevTotal ? prevTotal + total : total;
  }


  tripsSummary() {
    let trips = {};

    for (let trip of this.getSelectedTrips()) {
      if (trips[trip.priorityClient.displayName]) {
        trips[trip.priorityClient.displayName] = {
          miles: trips[trip.priorityClient.displayName].miles + trip.milage,
          legs: trips[trip.priorityClient.displayName].legs + 1,
          total:
            trips[trip.priorityClient.displayName].total +
            trip.preSpecialRate,
        };
      } else {
        trips[trip.priorityClient.displayName] = {
          miles: trip.milage,
          legs: 1,
          total: trip.preSpecialRate,
        };
      }
    }

    let date = this.searchDate;

    if (this.jobType === "cooperate") {
      date = this.dateRange;
    }

    const table = [
      [
        (this.user.company
          ? this.user.company.displayName
          : this.user.displayName) || "",
        " ",
        " ",
        " ",
        date && typeof date !== "string"
          ? moment(date[0]).tz(this.user.timeZone).format("MM/DD/YY") +
          " - " +
          moment(date[1]).tz(this.user.timeZone).format("MM/DD/YY")
          : moment(date).tz(this.user.timeZone).format("MM/DD/YY"),
        " ",
      ],
      [" ", " ", " ", " ", " ", " "],
      ["First Name", "Last Name", "Miles", "Legs", "$", "Per Trip"],
    ];

    let miles = 0;
    let total = 0;
    let legs = 0;

    for (let key in trips) {
      const t = [
        key.split(" ")[0],
        key.split(" ")[1] ? key.split(" ")[1] : "",
        trips[key].miles.toFixed(2),
        trips[key].legs,
        "$ " + trips[key].total,
        "$ " + (trips[key].total / trips[key].legs).toFixed(2),
      ];

      miles = miles + trips[key].miles;
      total = total + trips[key].total;
      legs = legs + trips[key].legs;

      table.push(t);
    }
    table.push([" ", " ", " ", " ", " ", " "]);

    table.push([
      " ",
      " ",
      miles.toFixed(2),
      legs,
      "$ " + total,
      " ",
    ]);

    exportToCsv(`trips-summary-${moment().format("MM-DD-YYYY")}.csv`, table);
  }

  cancelledTrips() {
    if (!this.selectedCorporateId) {
      sweetAlert("Error", "Please select a funding source first.", "warning", "Ok");
      return;
    }

    const cancelled = this.dataList.filter((trip) => trip.status === "cancelled");

    if (!cancelled.length) {
      sweetAlert("Error", "No cancelled trips found for the selected funding source.", "warning", "Ok");
      return;
    }

    this.isCancelledTripsLoading = true;
    const documentDefinition = cancelledTripsReport(
      cancelled,
      this.selectedCorporateUser ? this.selectedCorporateUser.displayName : "",
      this.user
    );
    generatePdf(documentDefinition, "download", `cancelled-trips-${moment().format("MM-DD-YYYY")}`);
    this.isCancelledTripsLoading = false;
  }

  async veridaTrfReport() {
    if (!this.selectedCorporateUser || !this.selectedDriver) {
      sweetAlert("Error", "Please select a funding source and a driver first.", "warning", "Ok");
      return;
    }

    const trips = this.getSelectedTrips();
    if (!trips.length) {
      sweetAlert("Error", "Please select at least one trip.", "warning", "Ok");
      return;
    }

    this.isVeridaTrfLoading = true;

    // A date-range selection can pull in trips from several different days -
    // Verida's form is a single day's log, so group by the trip's own day
    // and generate one file per day instead of lumping every selected day
    // into one report with a single (wrong) header date.
    const tripsByDay = new Map<string, any[]>();
    for (const trip of trips) {
      const dayKey = moment(trip.scheduleTime).tz(this.user.timeZone).format("YYYY-MM-DD");
      if (!tripsByDay.has(dayKey)) {
        tripsByDay.set(dayKey, []);
      }
      tripsByDay.get(dayKey).push(trip);
    }
    const dayKeys = Array.from(tripsByDay.keys()).sort();

    const providerCompany = this.user.company ? this.user.company : this.user;

    try {
      for (const dayKey of dayKeys) {
        await this.generateVeridaTrfForDay(tripsByDay.get(dayKey), dayKey, providerCompany);
      }
    } finally {
      this.isVeridaTrfLoading = false;
    }
  }

  private async generateVeridaTrfForDay(dayTrips: any[], dayKey: string, providerCompany): Promise<void> {
    const sorted = [...dayTrips].sort(
      (a, b) => new Date(a.scheduleTime).getTime() - new Date(b.scheduleTime).getTime()
    );

    const header: TrfHeader = {
      stateName: this.getStateName(providerCompany.stateCode),
      netProvider: this.user.company ? this.user.company.displayName : this.user.displayName,
      date: moment(dayKey, "YYYY-MM-DD").format("MM/DD/YYYY"),
      driverName: sorted[0].driver ? sorted[0].driver.displayName : "",
      lastFourVin: this.fleet && this.fleet.vin ? this.fleet.vin.slice(-4) : "",
      licensePlate: this.fleet ? this.fleet.driverCarNumber : "",
      vehicleOdometer: "",
      driverSignature:
        sorted[0].driver && sorted[0].driver.driverSignatureImage
          ? sorted[0].driver.driverSignatureImage
          : "",
    };

    console.log("[VeridaTRF] raw selected trips for", dayKey, ":", sorted);

    const legs: TripLeg[] = sorted.map((trip) => {
      // "On Scene At" - when the driver arrived to pick the member up.
      // Many cancelled trips never get that far, so fall back to the
      // trip's originally scheduled time rather than leaving this blank.
      const pickupTime =
        this.getTrackedTime(trip, "jobArrived") ||
        (trip.scheduleTime ? moment(trip.scheduleTime).tz(this.user.timeZone).format("HHmm") : "");
      
      const jobStarted = this.getTrackedTime(trip, "jobStarted"); // member onboard
      const jobFinished = this.getTrackedTime(trip, "jobFinished"); // member dropped off
      const cancelReason = this.getCancelReason(trip);

      return {
        memberName: trip.priorityClient ? trip.priorityClient.displayName : "",
        legId: trip.extraId ? trip.extraId : "",
        pickupTime,
        // Documented as the scheduled appointment time, not the actual tracked finish time.
        dropoffTime: trip.status === "cancelled" ? "" : jobFinished,
        // MBR Call column shows the pickup time, not the on-way/dispatch time.
        mbrCall: jobStarted,
        // trip.odometerStart/Stop are the manually-adjusted billing values;
        // fall back to the job's own tracked reading when no adjustment was made.
        pickupOdo: this.getOdometerReading(trip, "odometerStart"),
        dropoffOdo: trip.status === "cancelled" ? "" : this.getOdometerReading(trip, "odometerStop"),
        transportCode: this.mapTransportCode(trip),
        escortName: trip.noOfEscorts || "",
        escortRel: "",
        comments: "",
        signature: trip.signatureImage || "",
        // Same no-show detection this app already uses elsewhere (see
        // isStringExist(['no show', 'not show', 'cad'], ...) in
        // trip-reports.component.html/.ts) - reason text varies ("Member No
        // Show", "Passenger Not Show", CAD-coded reasons), so matching only
        // "no show" missed real cases and left everything as "C".
        tripStatus:
          trip.status === "cancelled" ? (this.isNoShowReason(cancelReason) ? "NS" : "C") : undefined,
      };
    });

    // Complete Vehicle Odometer: the earliest trip's Pick-Up Odometer -
    // not necessarily leg 1, since that trip may not have one set while a
    // later one does.
    const firstLegWithOdo = legs.find((leg) => leg.pickupOdo);
    header.vehicleOdometer = firstLegWithOdo ? firstLegWithOdo.pickupOdo : "";
    console.log("[VeridaTRF] vehicleOdometer resolved to:", header.vehicleOdometer, "from legs:", legs.map(l => ({ pickupOdo: l.pickupOdo, dropoffOdo: l.dropoffOdo })));

    await this.veridaTrfService.generate(header, legs);
  }

  private getStateName(stateCode: string): string {
    const STATE_NAMES: { [code: string]: string } = {
      AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
      CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
      HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
      KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
      MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
      MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
      NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
      OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
      SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
      VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
      DC: "District of Columbia",
    };
    if (!stateCode) { return ""; }
    return STATE_NAMES[String(stateCode).toUpperCase()] || stateCode;
  }

  private getOdometerReading(trip, key: "odometerStart" | "odometerStop"): string {
    if (trip[key] != null && trip[key] !== "") { return String(trip[key]); }
    if (trip.job && trip.job[key] != null && trip.job[key] !== "") { return String(trip.job[key]); }
    return "";
  }

  private getTrackedTime(trip, key: "jobAccepted" | "jobArrived" | "jobStarted" | "jobFinished"): string {
    const flat = trip.trackInfoJob && trip.trackInfoJob[key] && trip.trackInfoJob[key].time;
    const nested = trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob[key] && trip.job.trackInfoJob[key].time;
    const time = flat || nested;
    return time ? moment(time).tz(this.user.timeZone).format("HHmm") : "";
  }

  private getCancelReason(trip): string {
    const flat = trip.trackInfoJob && trip.trackInfoJob.jobCancelled && trip.trackInfoJob.jobCancelled.jobCancelReason;
    const nested =
      trip.job &&
      trip.job.trackInfoJob &&
      trip.job.trackInfoJob.jobCancelled &&
      trip.job.trackInfoJob.jobCancelled.jobCancelReason;
    return flat || nested || trip.changeReason || "";
  }

  // Matches the no-show substrings this app already checks elsewhere (see
  // isStringExist(['no show', 'not show', 'cad'], assign.changeReason) in
  // trip-reports.component.ts) instead of only "no show".
  private isNoShowReason(reason: string): boolean {
    const NO_SHOW_SUBSTRINGS = ["no show", "not show", "cad"];
    const lower = (reason || "").toLowerCase();
    return NO_SHOW_SUBSTRINGS.some((substring) => lower.includes(substring));
  }

  private mapTransportCode(trip): "A" | "W" | "S" {
    const description = (
      (this.preSpaceTypes &&
        trip.spaceType &&
        this.preSpaceTypes[trip.spaceType] &&
        this.preSpaceTypes[trip.spaceType].description) ||
      ""
    );
    // // Space type titles are free text - some are spelled out ("Wheelchair"),
    // // others use the app's own short codes ("WCH"/"STR"/"AMB" from
    // // spaceTypeList in utils.common.ts). Match both, or this silently falls
    // // through to "A" for every trip whose title uses the short code.
    // if (/wheelchair|\bwch\b/.test(title)) return "W";
    // if (/stretcher|\bstr\b|\bgur\b/.test(title)) return "S";
    return description || "A";
  }

  async ahcccsReport() {
    this.isAHCCCSFile = true;
    let trips = {};

    for (let trip of this.getSelectedTrips()) {
      // if (trips[trip.priorityClient.displayName]) {
      //   trips[trip.priorityClient.displayName].push(trip)
      // } else {
      //   trips[trip.priorityClient.displayName] = [trip]
      // }
      const date = moment(trip.scheduleTime)
        .tz(this.user.timeZone)
        .format("MM-DD-YYYY");
      if (trips[date]) {
        if (trips[date][trip.priorityClient.displayName]) {
          trips[date][trip.priorityClient.displayName].push(trip);
        } else {
          trips[date][trip.priorityClient.displayName] = [trip];
        }
      } else {
        trips[date] = { [trip.priorityClient.displayName]: [trip] };
      }
    }

    for (let myDate in trips) {
      for (let trip in trips[myDate]) {
        await this.cms1500Service.ahcccsReport(
          myDate,
          trips[myDate][trip],
          this.user
        );
      }
    }
    this.isAHCCCSFile = false;
  }

  downloadDriverLog() {
    let sortedTrips = this.getSelectedTrips();
    //.sort(
    //   (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    // );

    this.driverLoader.isLoading = true;
    this.driverLogService.dailyDriverLog(
      sortedTrips,
      this.user,
      this.driverLoader
    );
  }
  downloadMemberLog() {
    this.memberLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    let tripsGroupedByDate = {};
    sortedTrips.forEach((trip) => {
      let dateKey = moment(trip.scheduleTime).format("YYYY/MM/DD");

      tripsGroupedByDate[dateKey] = tripsGroupedByDate[dateKey] || {
        trips: [],
      };
      tripsGroupedByDate[dateKey].trips.push(trip);
    });
    this.memberLogService.dailyMemberLog(
      tripsGroupedByDate,
      this.user,
      this.memberLoader,
      this.selectedCorporateUser
    );
  }


  downloadCompletedReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.dateRange[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.dateRange[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // return;
    this.csvService.generateCompletedTripReport(data);
  }

  async resubmissionFormReport() {
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getResubmissionReport(sortedTrips, this.user, sortedTrips[0].driver, this.tempVin, this.dateRange[0],this.preSpaceTypes);
    }
  }

  prodCheck() {
    if (this.isProduction) {
      const companyId = this.user.company ? this.user.company._id : this.user._id
      if (companyId === '6463be83c60e5d659486581f') {
        return true;
      } else {
        return false;
      }

    }
    else {
      return true
    }
  }

  async downloadPatientReport(){

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getInvoiceCSV2(payload).subscribe(data => {
      if (data) {
        this.reportService.getMBMReport(data.workSheets[0], this.selectedMember);

      }
    })
  }


  mtmClaimFile() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date: moment(this.dateRange[0]).format("MM/DD/YYYY") + " - " + moment(this.dateRange[1]).format("MM/DD/YYYY"),
      trips,
      timezone: this.timeZone,
      preFleet : this.preFleet
    };
    this.csvService.downloaMTMClaimFile(data);
  }

  mtmClaimFileV2() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date: moment(this.dateRange[0]).format("MM/DD/YYYY"),
      trips,
      timezone: this.timeZone,
      preFleet : this.preFleet
    };
    this.csvService.downloaMTMClaimFileV2(data);
  }

  async downloadMTMDriverLog(){

    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();
    this.reportService.getMTMDriverLog(trips , this.user);
  }


  access2CareDriverLog() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:  this.dateRange[0],
      companyImage: this.companyImage
    }

    this.assignTripService
      .access2CareDriverLog(this.selectedDriver, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          let name = data.pdfName;
          let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
          downloadFile(url, '', name);
        }
      });
  }

  mtmAllDriverLogs(singleDriver:boolean) {
    let payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:  this.dateRange[0],
      companyImage: this.companyImage
    } as any;
    if(singleDriver){
      payload.driver = this.selectedDriver
    }


    this.assignTripService
      .donwloadAllDriverLog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          let name = data.pdfName;
          let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
          downloadFile(url, '', name);
        }
      });
  }

  // single driver log
  // mtmDriverLog() {
  //   const payload = {
  //     type: this.status,
  //     _ids: this.selectedTrips,
  //     scheduleTime: this.todayDate,
  //     companyImage: this.companyImage,
  //     driver : this.selectedDriver
  //   }

  //   this.assignTripService
  //     .donwloadDriverLog(payload)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         let name = data.pdfName;
  //         let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
  //         downloadFile(url, '', name);
  //       }
  //     });
  // }


  downloadCorporateInvoice2() {
    const selectedCorporate = this.corporateUsers.find(corporate => corporate._id === this.selectedCorporateUser._id);
    this.corporateLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips();
    this.corporateReportService.getCorporateReport(
      sortedTrips,
      this.user,
      selectedCorporate,
      this.dateRange,
      this.corporateLoader,
      this.preSpaceTypes
    );
  }

  async downloadHealthInvoice() {
    this.simpleCorporateInvoiceLoader.isLoading = true;

    const trips = this.getSelectedTrips().sort(
      (a: any, b: any) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    const corporateLogoUrl = this.selectedCorporateUser && this.selectedCorporateUser.profileImageURL;
    const corporateLogo = corporateLogoUrl ? await urlToBase64(corporateLogoUrl) : null;

    const userLogoUrl = this.user && this.user.profileImageURL;
    const userLogo = userLogoUrl ? await urlToBase64(userLogoUrl) : null;

    const userContactNumber = (this.user && (this.user.company ? this.user.company.contactNumber : this.user.contactNumber)) || '';

    const userSupportEmail = (this.user && this.user.supportEmail) || '';

    const corporateEmail = (this.selectedCorporateUser && this.selectedCorporateUser.email) || '';
    const corporateAddress = (this.selectedCorporateUser && this.selectedCorporateUser.address) || '';
    const corporateContactNumber = (this.selectedCorporateUser && this.selectedCorporateUser.contactNumber) || '';

    const invoiceNo = 'INV-' + getRandomString(6);

    const userAddressParts = ((this.user && this.user.address) || '')
      .split(',')
      .map((part: string) => part.trim())
      .filter((part: string) => part && part !== '0');
    const userAddressLine1 = userAddressParts[0] || '';
    const userAddressLine2 = userAddressParts.slice(1).join(', ');

    const periodCovered = this.dateRange && this.dateRange.length
      ? moment(this.dateRange[0]).format('MM/DD/YYYY') + ' To ' + moment(this.dateRange[1]).format('MM/DD/YYYY')
      : '';

    const tripRows = trips.map((trip) => {
      const scheduleTime = trip.scheduleTime
        ? moment(trip.scheduleTime).tz(this.timeZone).format('MM/DD/YYYY') + '\n' + moment(trip.scheduleTime).tz(this.timeZone).format('HHmm')
        : '';
      const earning = trip.preSpecialRate != null && trip.preSpecialRate !== '' ? Number(trip.preSpecialRate) : 0;
      const addons = (trip.addonServices || [])
        .map((addon) => addon.title
          + (addon.quantity != null ? ' x' + addon.quantity : '')
          + (addon.fare != null ? ' $' + Number(addon.fare).toFixed(2) : ''))
        .join('\n');

      return [
        { text: trip.tripId || trip.refTripId || '', fontSize: 8 },
        { text: scheduleTime, fontSize: 8 },
        { text: (trip.priorityClient && trip.priorityClient.displayName) || '', fontSize: 8 },
        { text: trip.jobOriginAddress || '', fontSize: 8 },
        { text: trip.jobDestinationAddress || '', fontSize: 8 },
        { text: addons, fontSize: 8 },
        { text: '$ ' + earning.toFixed(2), fontSize: 9, bold: true, alignment: 'right' },
      ];
    });

    const totalEarning = trips.reduce((sum, trip) => {
      const earning = trip.preSpecialRate != null && trip.preSpecialRate !== '' ? Number(trip.preSpecialRate) : 0;
      return sum + earning;
    }, 0);

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 60],

      content: [
        // ---------- Top row: sender block (right, company name above address) ----------
        {
          columns: [
            {
              width: '*',
              text: '',
            },
            {
              width: 'auto',
              columns: [
                {
                  width: 'auto',
                  stack: [
                    { text: (this.user.company ? this.user.company.displayName : this.user.displayName) || '', bold: true, fontSize: 11, alignment: 'right', margin: [0, 0, 0, 2] },
                    { text: userAddressLine1, alignment: 'right', fontSize: 9 },
                    ...(userAddressLine2 ? [{ text: userAddressLine2, alignment: 'right', fontSize: 9 }] : []),
                    { text: userContactNumber, alignment: 'right', fontSize: 9 },
                  ],
                  margin: [0, 0, 8, 0],
                },
                {
                  width: 1,
                  canvas: [{ type: 'line', x1: 0, y1: 0, x2: 0, y2: 58, lineWidth: 1, lineColor: '#cccccc' }],
                },
                {
                  width: userLogo ? 45 : 0,
                  stack: userLogo ? [{ image: 'userLogo', fit: [45, 45], margin: [8, 0, 0, 0] }] : [],
                },
              ],
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // ---------- Recipient block (logo + name/address) + Invoice title (right) ----------
        {
          columns: [
            {
              width: 40,
              stack: corporateLogo ? [{ image: 'corporateLogo', width: 40 }] : [],
            },
            {
              width: '*',
              stack: [
                { text: (this.selectedCorporateUser && this.selectedCorporateUser.displayName) || '', bold: true, fontSize: 11, margin: [8, 0, 0, 2] },
                { text: corporateAddress, fontSize: 9, margin: [8, 0, 0, 0] },
                { text: corporateEmail, fontSize: 9, margin: [8, 0, 0, 0] },
                { text: corporateContactNumber, fontSize: 9, margin: [8, 0, 0, 0] },
              ],
            },
            {
              width: 'auto',
              stack: [
                { text: 'Corporate Invoice', bold: true, fontSize: 16 },
              ],
              alignment: 'right',
              margin: [0, 10, 0, 0],
            },
          ],
          margin: [0, 0, 0, 24],
        },

        // ---------- Period / Report No row ----------
        {
          columns: [
            {
              width: '*',
              stack: [
                { text: 'Period Covered:', bold: true, fontSize: 9 },
                { text: periodCovered, fontSize: 9 },
              ],
            },
            {
              width: 'auto',
              stack: [
                { text: 'Invoice No:', bold: true, fontSize: 9, alignment: 'right' },
                { text: invoiceNo, fontSize: 9, alignment: 'right' },
              ],
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // ---------- Trip table ----------
        {
          table: {
            headerRows: 1,
            dontBreakRows: true,
            widths: [55, 50, 55, '*', '*', 60, 55],
            body: [
              [
                { text: 'ID', style: 'tableHeader' },
                { text: 'Time', style: 'tableHeader' },
                { text: 'Member', style: 'tableHeader' },
                { text: 'Pick Up', style: 'tableHeader' },
                { text: 'Drop Off', style: 'tableHeader' },
                { text: 'Addons', style: 'tableHeader' },
                { text: 'Total', style: 'tableHeader', alignment: 'right' },
              ],
              ...tripRows,
            ],
          },
          layout: {
            hLineWidth: function (i: number, node: any) {
              return (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0;
            },
            vLineWidth: function () { return 0; },
            hLineColor: function () { return '#cccccc'; },
            paddingTop: function () { return 8; },
            paddingBottom: function () { return 8; },
          },
        },

        // ---------- Total (directly below the trip table) ----------
        {
          text: 'Total: $ ' + totalEarning.toFixed(2),
          alignment: 'right',
          bold: true,
          fontSize: 11,
          margin: [0, 12, 0, 0],
        },
      ],

      // ---------- Footer (only on the last page, bottom-anchored) ----------
      footer: function (currentPage: number, pageCount: number) {
        if (currentPage !== pageCount) {
          return null;
        }
        return {
          stack: [
            { text: 'Thank You For Your Business!', alignment: 'center', bold: true, fontSize: 10, margin: [0, 0, 0, 8] },
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    { text: 'For support: ' + userSupportEmail, alignment: 'center', fontSize: 8, color: '#666666', border: [true, true, true, true] },
                  ],
                ],
              },
              layout: {
                hLineWidth: function () { return 1; },
                vLineWidth: function () { return 1; },
                hLineColor: function () { return '#dddddd'; },
                vLineColor: function () { return '#dddddd'; },
                paddingTop: function () { return 8; },
                paddingBottom: function () { return 8; },
              },
            },
          ],
          margin: [40, 10, 40, 0],
        };
      },

      images: {
        corporateLogo: corporateLogo,
        userLogo: userLogo,
      },

      styles: {
        tableHeader: {
          bold: true,
          fontSize: 9,
          fillColor: '#f5f5f5',
        },
      },

      defaultStyle: {
        fontSize: 9,
      },
    };

    await generatePdf(docDefinition, 'download', 'Health-Invoice');
    this.simpleCorporateInvoiceLoader.isLoading = false;
  }

  manifestLogistic() {
    const payload = {
      tempVin: this.tempVin,
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadLogisticareManifest(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }
  claimFile(isPuDo) {
    const payload = {
      isPuDo: isPuDo,
      tempVin: this.tempVin,
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .claimFile(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }
  mtmClaim() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadMtmClaim(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  callthecarInvoicev2() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };
    this.assignTripService
      .donwloadCallTheCarInvoice(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  billedtomodivcare() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .billedToModivcare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList.forEach((assign) => {
            const assignIndex = this.selectedTrips.indexOf(
              assign._id.toString()
            );
            if (assignIndex > -1) {
              assign.bankStatus = "banked";
              assign.isSelected = false;
              this.selectedTrips.splice(assignIndex, 1);
            }
          });
        }
      });
  }

  RepushToCTC() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .rePushToCTC(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList.forEach((assign) => {
            const assignIndex = this.selectedTrips.indexOf(
              assign._id.toString()
            );
            if (assignIndex > -1) {
              assign.bankStatus = "banked";
              assign.isSelected = false;
              this.selectedTrips.splice(assignIndex, 1);
            }
          });
        }
      });
  }

  corporateInvoiceReport() {
    let payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    if (this.dateRange && this.dateRange.length) {
      payload["startDate"] = this.dateRange[0];
      payload["endDate"] = this.dateRange[1];
    }

    this.assignTripService
      .donwloadCorporateInvoiceReport(this.selectedCorporateId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  corporateInvoice() {
    // Corporate TRF
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadCorporateInvoice(this.selectedCorporateId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  async memberTripsLogHHT(fileName?) {
    this.isMemberTripsLogDownloading = true;

    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      cooperate: this.selectedCorporateUser,
    };

    this.assignTripService
      .memberTripsLogHHT(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isMemberTripsLogDownloading = false;
        }
      });
  }

  // memberTripsLogHMT
  async memberTripsLogHMT(fileName?) {
    this.isTripsLogHMTLoading = true;

    const payload = {
      type: 'adjustedtriplogs',
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.selectedCorporateUser ? this.selectedCorporateUser.profileImageURL : ''
    };

    this.assignTripService
      .memberTripsLogHMT(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isTripsLogHMTLoading = false;
        }
      });
  }

  async memberTripsLog(fileName?) {
    this.isMemberMBRloading = true;

    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .memberTripsLog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {

          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isMemberMBRloading = false;
        }
      });
  }

  cameraTripsLog() {
    this.isMemberFile = true;
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .cameraTripslog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.isMemberFile = false;
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  restrictToDigits(event) {
    const input = event.target;
    const cleaned = input.value.replace(/[^0-9]/g, '');
    if (input.value !== cleaned) {
      input.value = cleaned;
    }
  }

  onInlineTimestampInput(event, assign, timestampKey: string) {
    if (!assign.trackInfoJob || !assign.trackInfoJob[timestampKey]) return;

    const timerKey = assign._id + '_' + timestampKey;
    if (!this.debounceTimers) {
      this.debounceTimers = {};
    }

    if (this.debounceTimers[timerKey]) {
      clearTimeout(this.debounceTimers[timerKey]);
    }

    this.debounceTimers[timerKey] = setTimeout(() => {
      delete this.debounceTimers[timerKey];
      this.saveInlineTimestamp(event, assign, timestampKey);
    }, 3000);
  }

  onInlineTimestampChange(event, assign, timestampKey: string) {
    const timerKey = assign._id + '_' + timestampKey;
    if (this.debounceTimers && this.debounceTimers[timerKey]) {
      clearTimeout(this.debounceTimers[timerKey]);
      delete this.debounceTimers[timerKey];
    }
    this.saveInlineTimestamp(event, assign, timestampKey);
  }

  saveInlineTimestamp(event, assign, timestampKey: string) {
    if (!assign.trackInfoJob || !assign.trackInfoJob[timestampKey]) return;

    const rawValue = event.target.value.trim();
    if (!rawValue) {
      this.toastr.error('Time cannot be empty', 'Error');
      const originalTime = moment(assign.trackInfoJob[timestampKey].time).tz(this.timeZone);
      event.target.value = originalTime.format('HHmm');
      return;
    }

    // Parse HHmm format (e.g. "1430" or "0830")
    let hours: number;
    let minutes: number;

    if (rawValue.length === 4 && /^\d{4}$/.test(rawValue)) {
      hours = parseInt(rawValue.substring(0, 2), 10);
      minutes = parseInt(rawValue.substring(2, 4), 10);
    } else {
      this.toastr.error('Invalid time format. Use HHmm (e.g. 1430)', 'Error');
      // Reset the input to the original value
      const originalTime = moment(assign.trackInfoJob[timestampKey].time).tz(this.timeZone);
      event.target.value = originalTime.format('HHmm');
      return;
    }

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      this.toastr.error('Invalid time. Hours must be 00-23, minutes 00-59.', 'Error');
      const originalTime = moment(assign.trackInfoJob[timestampKey].time).tz(this.timeZone);
      event.target.value = originalTime.format('HHmm');
      return;
    }

    const currentTime = moment(assign.trackInfoJob[timestampKey].time).tz(this.timeZone);

    // Skip if value hasn't changed
    if (currentTime.hour() === hours && currentTime.minute() === minutes) return;

    const updatedTime = currentTime
      .set({ hour: hours, minute: minutes, second: 0 })
      .toISOString();

    assign.trackInfoJob[timestampKey].time = updatedTime;

    // Update the input display value
    event.target.value = moment(updatedTime).tz(this.timeZone).format('HHmm');

    const payload = {
      trackInfoJob: assign.trackInfoJob,
    };

    this.dispatchCenterService
      .saveTripAdjustment(assign._id, payload, true)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.toastr.success('Timestamp updated successfully', 'Success');
            if (event && event.target && typeof event.target.blur === 'function') {
              event.target.blur();
            }
          }
        },
        (err) => {
          sweetAlert('Error', err, 'error', 'OK');
        }
      );
  }

  /**
   * Same cascade as Adjustment form onFinishedTimeChange:
   * Finished → Completed (-2m) → Started (-routeDuration) → Arrived (-5m) → Accepted (-5m)
   */
  async settleTimestampsFromFinished(assign) {
    if (!assign || !assign.trackInfoJob || !assign.trackInfoJob.jobFinished || !assign.trackInfoJob.jobFinished.time) {
      return false;
    }

    let durationMinutes = 15;
    try {
      const routingDistance: any = await this.assignTripService
        .getRoutingDistance(
          assign.jobOriginLatitude,
          assign.jobOriginLongitude,
          assign.jobDestinationLatitude,
          assign.jobDestinationLongitude
        )
        .toPromise();
      const segments =
        routingDistance &&
        routingDistance.features &&
        routingDistance.features[0] &&
        routingDistance.features[0].properties &&
        routingDistance.features[0].properties.segments;
      if (segments && segments[0] && segments[0].duration) {
        durationMinutes = segments[0].duration / 60;
      }
    } catch (e) {
      // keep fallback duration
    }

    const finishedTime = moment(assign.trackInfoJob.jobFinished.time);
    const completedTime = finishedTime.clone().subtract(2, 'minutes');
    const startedTime = completedTime.clone().subtract(durationMinutes, 'minutes');
    const arrivedTime = startedTime.clone().subtract(5, 'minutes');
    const acceptedTime = arrivedTime.clone().subtract(5, 'minutes');

    if (!assign.trackInfoJob.jobCompleted) {
      assign.trackInfoJob.jobCompleted = {};
    }
    if (!assign.trackInfoJob.jobStarted) {
      assign.trackInfoJob.jobStarted = {};
    }
    if (!assign.trackInfoJob.jobArrived) {
      assign.trackInfoJob.jobArrived = {};
    }
    if (!assign.trackInfoJob.jobAccepted) {
      assign.trackInfoJob.jobAccepted = {};
    }

    assign.trackInfoJob.jobCompleted.time = completedTime.toISOString();
    assign.trackInfoJob.jobStarted.time = startedTime.toISOString();
    assign.trackInfoJob.jobArrived.time = arrivedTime.toISOString();
    assign.trackInfoJob.jobAccepted.time = acceptedTime.toISOString();
    assign.created = acceptedTime.toISOString();

    return true;
  }

  async bulkTimestampAdjustment() {
    if (!this.selectedTrips || !this.selectedTrips.length) {
      this.toastr.error('Please select trips first', 'Error');
      return;
    }

    if (this.isBulkAdjustmentLoading) {
      return;
    }

    const trips = this.getSelectedTrips();
    if (!trips.length) {
      this.toastr.error('Please select trips first', 'Error');
      return;
    }

    this.isBulkAdjustmentLoading = true;
    let successCount = 0;
    let skipCount = 0;
    let failCount = 0;

    for (let i = 0; i < trips.length; i++) {
      const assign = trips[i];
      try {
        const settled = await this.settleTimestampsFromFinished(assign);
        if (!settled) {
          skipCount++;
          continue;
        }

        await this.dispatchCenterService
          .saveTripAdjustment(assign._id, { trackInfoJob: assign.trackInfoJob, created: assign.created }, true)
          .toPromise();
        successCount++;
      } catch (err) {
        failCount++;
      }
    }

    this.isBulkAdjustmentLoading = false;

    if (successCount) {
      this.toastr.success(successCount + ' trip(s) timestamps adjusted successfully', 'Success');
    }
    if (skipCount) {
      this.toastr.warning(skipCount + ' trip(s) skipped (missing finished time)', 'Warning');
    }
    if (failCount) {
      this.toastr.error(failCount + ' trip(s) failed to adjust', 'Error');
    }
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.preCorporate[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }

  ngOnDestroy(): void {
    if (this.debounceTimers) {
      for (const key of Object.keys(this.debounceTimers)) {
        clearTimeout(this.debounceTimers[key]);
      }
    }
  }

  onArrivedStatus(trip) {
    let status = "";
    const { trackInfoJob } = trip;
    if (trackInfoJob && trackInfoJob.jobArrived && trackInfoJob.jobArrived.time) {
      const diff = Math.round(
        moment(trip.scheduleTime).diff(moment(trackInfoJob.jobArrived.time)) / 60000
      );
      const isEarly = moment(trip.scheduleTime).isAfter(moment(trackInfoJob.jobArrived.time));
      if (isEarly) {
        status = diff <= 15 ? "On Time" : "Early";
      } else {
        status = Math.abs(diff) <= 15 ? "On Time" : "Late";
      }
    }
    return status;
  }

  onCompletedStatus(trip) {
    let status = "";
    const { trackInfoJob } = trip;
    if (trackInfoJob && trackInfoJob.jobCompleted && trackInfoJob.jobCompleted.time) {
      const diff = Math.round(
        moment(trip.appointmentTime).diff(moment(trackInfoJob.jobCompleted.time)) / 60000
      );
      const isLate = moment(trip.appointmentTime).isAfter(moment(trackInfoJob.jobCompleted.time));
      if (isLate) {
        status = diff <= 15 ? "On Time" : "Early";
      } else {
        status = Math.abs(diff) <= 15 ? "On Time" : "Late";
      }
    }
    return status;
  }

}
